// extracted by mini-css-extract-plugin
export default {"Page":"page-module_Page_QxVZJ","PageContent":"page-module_PageContent_tyxLn"};